import React, { useState, useEffect, useRef } from "react";
import "./robCalendar.style.scss";

const RobCalendar = ({
     placeholder = "Select a date",
     style,
     minYear = 2020,
     maxYear = 2035,
     dateIn,
     onDateChange,
}) => {
     const calendarRef = useRef(null);
     const today = new Date();
     const [view, setView] = useState("Calendar");
     const [monthNames] = useState([
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
     ]);
     const [dayNames] = useState(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]);
     const [calendarDays, setCalendarDays] = useState([]);
     const [selectedDate, setSelectedDate] = useState("");
     const [selectedYear, setSelectedYear] = useState(today.getFullYear());
     const [selectedMonth, setSelectedMonth] = useState(today.getMonth());
     const [possibleYears, setPossibleYears] = useState([]);
     const [isOpen, setIsOpen] = useState(false);

     useEffect(() => {
          generateCalendar(selectedYear, selectedMonth);
     }, [selectedYear, selectedMonth]);

     useEffect(() => {
          if (dateIn) {
            const parsed = new Date(dateIn);
            if (!isNaN(parsed)) {
              const formatted = parsed.toISOString().split("T")[0];
              setSelectedDate(formatted);
              setSelectedYear(parsed.getFullYear());
              setSelectedMonth(parsed.getMonth());
            }
          }
     }, [dateIn]);
        

     const generateCalendar = (year, month) => {
          const startOfMonth = new Date(year, month, 1);
          const endOfMonth = new Date(year, month + 1, 0);
          const startDay = startOfMonth.getDay();
          const daysInMonth = endOfMonth.getDate();
          const paddedDays = Array.from({ length: startDay }, () => "");
          const days = [...paddedDays, ...Array.from({ length: daysInMonth }, (_, i) => i + 1)];
          setCalendarDays(days);
     };

     const goToPreviousMonth = () => {
          if (selectedMonth === 0) {
               setSelectedMonth(11);
               setSelectedYear((prev) => prev - 1);
          } else {
               setSelectedMonth((prev) => prev - 1);
          }
     };

     const goToNextMonth = () => {
          if (selectedMonth === 11) {
               setSelectedMonth(0);
               setSelectedYear((prev) => prev + 1);
          } else {
               setSelectedMonth((prev) => prev + 1);
          }
     };

     const handleDayClick = (day) => {
          if (!day) return;
          const selected = new Date(selectedYear, selectedMonth, day);
          const formattedDate = selected.toISOString().split("T")[0];
          setSelectedDate(formattedDate);
          onDateChange?.(formattedDate);
          setIsOpen(false);
     };

     const switchToYearView = () => {
          const years = Array.from({ length: maxYear - minYear + 1 }, (_, i) => minYear + i);
          setPossibleYears(years);
          setView("Year");
     };

     const selectYear = (year) => {
          setSelectedYear(year);
          setView("Calendar");
     };

     const selectMonth = (monthIndex) => {
          setSelectedMonth(monthIndex);
          setView("Calendar");
     };

     return (
          <div className="rob-calendar-container" style={style}>
               <div className="rob-calendar-input" ref={calendarRef} onClick={() => setIsOpen(!isOpen)}>
                    <input
                         type="text"
                         value={selectedDate}
                         placeholder={placeholder}
                         readOnly
                         className="rob-calendar-input-field"
                    />
               </div>

               {isOpen && view === "Calendar" && (
                    <div className="rob-calendar-popup text-navy">
                         <div className="rob-calendar-header p-2 bg-navy d-flex gap-2 justify-content-between align-items-center">
                              <button className="btn btn-sm btn-warning" onClick={goToPreviousMonth}>{"<"}</button>
                              <div className="btn btn-sm btn-light w-75" onClick={switchToYearView}>{selectedYear}</div>
                              <div className="btn btn-sm w-75 btn-light" onClick={() => setView("Month")}>{monthNames[selectedMonth]}</div>
                              <button className="btn btn-sm btn-warning" onClick={goToNextMonth}>{">"}</button>
                         </div>

                         <div className="rob-calendar-days-header">
                              {dayNames.map((day, i) => <span key={i}>{day}</span>)}
                         </div>

                         <div className="rob-calendar-days">
                              {calendarDays.map((day, index) => (
                                   <div
                                        key={index}
                                        className={`rob-calendar-day ${day === parseInt(selectedDate.split("-")[2]) ? "selected" : ""
                                             } ${day === today.getDate() &&
                                                  selectedMonth === today.getMonth() &&
                                                  selectedYear === today.getFullYear()
                                                  ? "today"
                                                  : ""
                                             }`}
                                        onClick={() => handleDayClick(day)}
                                   >
                                        {day}
                                   </div>
                              ))}
                         </div>
                    </div>
               )}

               {isOpen && view === "Year" && (
                    <div className="rob-calendar-popup">
                         <div className="rob-year-grid">
                              {possibleYears.map((year) => (
                                   <button key={year} onClick={() => selectYear(year)}>{year}</button>
                              ))}
                         </div>
                    </div>
               )}

               {isOpen && view === "Month" && (
                    <div className="rob-calendar-popup">
                         <div className="rob-month-grid">
                              {monthNames.map((month, index) => (
                                   <button key={index} onClick={() => selectMonth(index)}>{month}</button>
                              ))}
                         </div>
                    </div>
               )}
          </div>
     );
};

export default RobCalendar;
